import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-secondary-200">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <span className="text-lg font-bold text-white mb-4 block" style={{ fontFamily: 'var(--font-label)' }}>
              43423漫画网
            </span>
            <p className="text-xs md:text-sm text-secondary-300 leading-relaxed mb-4 max-w-sm">
              {footerData.about}
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-full bg-secondary-700 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-white text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-secondary-700 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-weibo-line text-white text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-secondary-700 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-white text-sm"></i>
              </a>
            </div>
          </div>

          {footerData.sections.map((section, i) => (
            <div key={i}>
              <h3 className="text-sm font-semibold text-white mb-4 whitespace-nowrap">{section.title}</h3>
              <ul className="space-y-2.5">
                {section.links.map((link, j) => (
                  <li key={j}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                      className="text-xs md:text-sm text-secondary-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-secondary-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-secondary-400 whitespace-nowrap">
              &copy; 2019-2026 43423漫画网 版权所有
            </p>
            <div className="flex items-center gap-4 flex-wrap justify-center">
              <span className="text-xs text-secondary-400 whitespace-nowrap cursor-pointer hover:text-secondary-200 transition-colors">用户协议</span>
              <span className="text-xs text-secondary-400 whitespace-nowrap cursor-pointer hover:text-secondary-200 transition-colors">隐私政策</span>
              <span className="text-xs text-secondary-400 whitespace-nowrap cursor-pointer hover:text-secondary-200 transition-colors">版权声明</span>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-secondary-700/50">
          <h3 className="text-xs font-semibold text-secondary-300 mb-3">合作伙伴</h3>
          <p className="text-xs text-secondary-500">感谢所有合作伙伴对43423漫画网的支持与信赖</p>
        </div>
      </div>
    </footer>
  );
}